// import { ADDADMIN, ERROR, FORGETPASSWORD } from '../actions/ADDADMIN_action';
import { UPDATEADMINERROR, UPDATEADMINREQUEST, UPDATEADMINSUCCESS } from './../actions/actionTypes'

const initialState = {
    requestDone: false,
    isCreated: false,
    addAdminRequest:false,
    err : false,
    message:'',
  };
  
  // receiving response sent by action according to type of action
  export default function updateAdminReducers(state = initialState, action) {
      //console.log(action,'action')
      let {payload} = action
    switch (action.type) {

        case UPDATEADMINREQUEST:
          return { 
            requestDone: false,
            isCreated: false,
            addAdminRequest: true,
            err : false,
            message: payload.message,
           };
          break;
        case UPDATEADMINSUCCESS:
        return { 
            requestDone: true,
            isCreated: true,
            addAdminRequest: false,
            err : false,
            message: payload.message,
        };
        break;
  
        case UPDATEADMINERROR:
        return { 
            requestDone: true,
            isCreated: false,
            addAdminRequest: false,
            err : true,
            message: payload.message
        };
        break;
  
      
      default:
        return state;
    }
  }
  